import type { ReactElement } from "react";
import type { LineSeries, PointTooltipProps } from "@nivo/line";
import { computeDeltaPercent } from "@/react/components/SettingsApp/AnalyticsV4/hooks/utils/comparison";
import { formatDateLabel } from "../BarChartComponent/dateFormatting";

export const buildLineTooltip = (params: {
  previousData: Array<Record<string, unknown>> | null | undefined;
  seriesKeys: string[];
  currentXDomain: Array<string | number>;
  prevValuesOrdered: number[];
  dateGrouping?: string;
  renderMembersTooltip: (args: {
    xValue: string;
    currentValue: number;
    headerLabel: string;
    deltaPercent?: number;
  }) => ReactElement | null;
  customTooltip?: (p: PointTooltipProps<LineSeries>) => ReactElement | null;
}) => {
  const {
    previousData,
    seriesKeys,
    currentXDomain,
    prevValuesOrdered,
    dateGrouping,
    renderMembersTooltip,
    customTooltip,
  } = params;
  return (p: PointTooltipProps<LineSeries>): ReactElement | null => {
    if (previousData && seriesKeys.length === 1) {
      const point = p.point;
      const pointData = point?.data;
      const xVal = pointData?.x != null ? String(pointData.x) : "";
      const curVal =
        pointData?.y != null && typeof pointData.y === "number"
          ? pointData.y
          : 0;
      const idx = currentXDomain.findIndex(v => String(v) === xVal);
      const prevVal =
        idx >= 0 && idx < prevValuesOrdered.length ? prevValuesOrdered[idx] : 0;
      const delta = computeDeltaPercent(curVal, prevVal);
      const header = formatDateLabel(dateGrouping, xVal);
      return renderMembersTooltip({
        xValue: xVal,
        currentValue: curVal,
        headerLabel: header,
        deltaPercent: delta,
      });
    }
    return customTooltip ? customTooltip(p) : null;
  };
};
